import { useToast } from "../../../../components/toast";

export const useToastHandler = (store) => {
  const toast = useToast();

  const executeWithToast = async (storeMethod, ...args) => {
    try {
      const result = await storeMethod.apply(store, args);
      if (result?.message) {
        toast[result.variant]({
          title: result.title,
          message: result.message,
        });
      }
      return result;
    } catch (error) {
      toast.error({
        title: "Error",
        message: error.message || "An unexpected error occurred",
      });
      throw error;
    }
  };

  const executeSyncWithToast = (storeMethod, ...args) => {
    try {
      const result = storeMethod.apply(store, args);
      if (result?.message) {
        toast[result.variant]({
          title: result.title,
          message: result.message,
        });
      }
      return result;
    } catch (error) {
      toast.error({
        title: "Error",
        message: error.message || "An unexpected error occurred",
      });
      throw error;
    }
  };

  return {
    executeWithToast,
    executeSyncWithToast,
  };
};
